module.exports = __webpack_public_path__ + "img/3.9dd5e9c2.png";